/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Horizontal_Padding_AriaInputs */

const en_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontal Padding`)
};

const fr_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marge horizontale`)
};

const de_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontale Polsterung`)
};

const it_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imbottitura orizzontale`)
};

const ru_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Горизонтальная отступ`)
};

const es_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relleno horizontal`)
};

const zh_cn2_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平边距`)
};

const ja_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平パディング`)
};

const hi_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षैतिज पैडिंग`)
};

const pt_pt2_video_export_horizontal_padding_aria = /** @type {(inputs: Video_Export_Horizontal_Padding_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acolchoamento horizontal`)
};

/**
* | output |
* | --- |
* | "Horizontal Padding" |
*
* @param {Video_Export_Horizontal_Padding_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_horizontal_padding_aria = /** @type {((inputs?: Video_Export_Horizontal_Padding_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Horizontal_Padding_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_horizontal_padding_aria(inputs)
	if (locale === "de") return de_video_export_horizontal_padding_aria(inputs)
	if (locale === "it") return it_video_export_horizontal_padding_aria(inputs)
	if (locale === "ru") return ru_video_export_horizontal_padding_aria(inputs)
	if (locale === "es") return es_video_export_horizontal_padding_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_horizontal_padding_aria(inputs)
	if (locale === "ja") return ja_video_export_horizontal_padding_aria(inputs)
	if (locale === "hi") return hi_video_export_horizontal_padding_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_horizontal_padding_aria(inputs)
	return en_video_export_horizontal_padding_aria(inputs)
});